<div class="w-screen">
      <router-outlet></router-outlet>
      <iho-notification></iho-notification>
</div>